var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"md":"12"}},[_c('CCard',[_c('CCardBody',[_c('InventoryItemsListReport',{attrs:{"product_master_name":_vm.name,"models":_vm.unit_model_items}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }